<template>
  <div @click="closeMenu($event)" id="app">
    
    <div data-collapse="medium" data-animation="over-right" data-duration="400" class="navbar w-nav">
      <div>
      <div @click="openMenu($event)" class="menu-button w-nav-button">
        <div class="icon w-icon-nav-menu"></div>
      </div>
      <router-link to="/" class="brand w-nav-brand w--current"><img src="./assets/images/logo.jpeg" style="margin-top:8px;" width="250" alt="האתר ליחידות המוגברות"></router-link>
      <nav class="nav-menu w-clearfix w-nav-menu" :class="menu?'w--nav-menu-open':''">
        <router-link to="/alternatives" class="nav-link w-nav-link">תוכנית לימודים</router-link>
        <router-link to="/bagruyot" class="nav-link w-nav-link">פתרון בגרויות</router-link>
       <router-link to="/articles" class="nav-link w-nav-link">מאמרי העשרה</router-link>
        <router-link to="/contact" class="nav-link w-nav-link">יצירת קשר</router-link>
        <a href="https://hamikra.org" class="nav-link w-nav-link" target="_blank"><img src="./assets/images/logo.png" width="65" alt="החברה לחקר המקרא"></a>
        <router-link to="/login" v-if="!user" class="btn header w-button">כניסה למורים</router-link>
        <router-link to="/userarea" v-if="user" class="btn header zone w-button">איזור אישי</router-link>
        <a v-if="user" href="#" @click="signOut()" class="nav-link btn login">התנתק</a>
      </nav>
      </div>
    </div>

    <router-view class="mainCont"/>

      <div class="footer">
    <div class="_1200 footer w-clearfix">
    <router-link to="/" class="footer-logo w-inline-block"></router-link>
    <router-link to="/alternatives" class="footer-link">תוכנית לימודים</router-link>
    <router-link to="/bagruyot" class="footer-link">פתרון בגרויות</router-link>
    <router-link to="/articles" class="footer-link">מאמרי העשרה</router-link>
    <router-link to="/contact" class="footer-link">יצירת קשר</router-link>
      <div class="line"></div>
      <div class="share">
          <div class="sharebox">
          <p class="footer-link">נהנת? ספר לחברך</p>
          <a class="socialButton" title="שיתוף בפייסבוק" :href="'https://www.facebook.com/sharer/sharer.php?u=https://tanach5.org'"><img src="./assets/images/social/fa.svg"></a>
          <a class="socialButton" title="שיתוף בטוויטר" :href="'https://twitter.com/home?status=https://tanach5.org האתר ליחידות המוגברות בתנך'"><img src="./assets/images/social/tw.svg" ></a>
          <a class="socialButton" title="שליחה במייל" :href="'mailto:info@example.com?&subject=האתר ליחידות המוגברות בתנך&body=https://tanach5.org'"><img src="./assets/images/social/mail.svg" ></a>
          <a class="socialButton" :href="'whatsapp://send?text=האתר ליחידות המוגברות בתנך https://tanach5.org'" data-action="share/whatsapp/share"><img src="./assets/images/social/wa.svg" ></a>=
          </div>
        <a href="#" class="footer-icon-link w-inline-block">
          <img src="images/line.svg" alt="">
        </a>
        <a href="#" class="footer-icon-link w-inline-block"><img src="images/line-Copy.svg" alt=""></a><a href="#" class="footer-icon-link w-inline-block"><img src="images/line-Copy-2.svg" alt=""></a><a href="#" class="footer-icon-link w-inline-block"><img src="/images/line-Copy-3.svg" alt=""></a></div><a href="https://bagelstudio.co.il" target="_blank" class="bagel w-inline-block"><img src="images/bagel.svg" alt="" class="image-2"></a></div>
  </div>
  </div>
</template>


<script>
export default {
  data(){
    return{
      user:'',
      menu:false
    }
  },
  methods:{
    openMenu(e){
      e.stopPropagation()
      this.menu = true
    },
    closeMenu(e){
      if (this.menu && !$(e.target).closest('nav').length || $(e.target).closest('a').length){
        console.log(this.menu)
         this.menu = false
      }
    },
    signOut(){
      firebase.auth().signOut()
      this.user = ''
    }
  },
  mounted(){
    var usrApp = this
          firebase.auth().onAuthStateChanged((user)=>{
          if (user) {
          db.doc('/collections/nZSsggipwqsg74x8nJBu/items/'+user.uid).get().then((user)=>{
            if (user.exists){
            usrApp.user = user.data()
            usrApp.user.uid = user.id
            }
            }
          )
        }
      });
  }
}
</script>

<style>
@import './css/webflow.css';
@import './css/normalize.css';
@import './css/yihidon-mogbrot.webflow.css';

.w--nav-menu-open a{
  display: block;
  margin-left:auto!important;
  margin-right:auto;
}
.w--nav-menu-open{
  position: fixed;
  width: 80%;
  bottom:0;
}
.mainCont{
  min-height: calc(100vh - 180px);
  height:auto;
}
.sharebox{
      display: inline-block;
}
.socialButton{
  margin-right:10px;
  margin-left:10px;
}

nav{
  box-shadow:5px 5px 5px rgba(0,0,0,0.1);
}
.brand.w-nav-brand{
  margin-right: 20px;
}
  #app{
    margin-top:90px;
  }
   nav .btn.header.w-button{
     margin-left:15px;
   }
  .navbar.w-nav{
    background: white;
    position: fixed;
    top:0;
    left:0;
    right:0;
  }

.nav-link.btn.login{
  margin-left:5px;
  text-decoration: none;
  line-height:43px;
  margin-top:18px;
}
.showmore::after {
  padding-right: 10px;
  content: url('https://uploads-ssl.webflow.com/5c5ff615f3edced5c3c0aedd/5c614353d885ee8490d1de43_arrow.svg');
}
	@media only screen and (max-width: 1111px) {
  .nav-link{
  padding-left: 15px;
  padding-right: 15px;  
  }}

</style>
